<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-header border-0 bg-white rounded-top py-3">
      <button
        type="button"
        class="btn-close ms-auto"
        @click="closeModal"
      />
    </div>

    <div class="modal-body bg-white px-4 pb-4 pt-0">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto mb-3">
          <div class="mx-auto text-center">
            <div
              class=" d-inline-flex align-items-center justify-content-center mb-3"
              style="width: 80px; height: 80px;"
            >
              <img
                :src="`${aws}/unicorn-feather.png`"
                class="mx-auto mb-3"
              >
            </div>
          </div>
        </div>

        <h4 class="text-center mb-3 fw-bold">
          Attention !
        </h4>

        <div class="alert alert-danger border-0 mb-4 ">
          <ul class="custom-cross-list mb-0 ps-3">
            <li class="mb-2">
              Vous êtes sur le point de supprimer définitivement votre compte.
            </li>
            <li class="mb-2">
              Vos données personnelles seront supprimées.
            </li>
            <li>
              Vous ne pourrez plus accéder à votre compte.
            </li>
          </ul>
        </div>

        <div class="d-flex flex-column flex-md-row gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary flex-fill order-2 order-md-1"
            @click="closeModal"
          >
            Annuler
          </button>
          <button
            type="button"
            class="btn btn-danger flex-fill order-1 order-md-2"
            :disabled="isDeleting"
            @click="confirmDeletion"
          >
            <span
              v-if="isDeleting"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
            {{ isDeleting ? 'Suppression en cours...' : 'Confirmer la suppression' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ui } from '@/mixins';

export default {
  name: 'DeleteAccountModal',
  mixins: [ui],
  data() {
    return {
      isDeleting: false,
    };
  },
  computed: {
       aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    closeModal() {
      if (!this.isDeleting) {
        this.ui_showModal(false);
      }
    },
    async confirmDeletion() {
      this.isDeleting = true;
      try {
        const userId = this.$store.state.client.clientId;
        await this.$store.dispatch('client/removeMember', userId);
        this.ui_showModal(false);

        await this.$store.dispatch('client/disconnect');
        this.$router.push('/deleted-account');

      } catch (error) {
        console.error('Erreur lors de la suppression du compte:', error);

        const errorMessage = error?.response?.data?.error?.message;
        const message = errorMessage === 'Cannot delete user'
          ? 'Nous ne pouvons pas supprimer votre compte, veuillez contacter support@assurup.com'
          : 'Une erreur est survenue lors de la suppression du compte';

        await this.ui_showToast({
          show: true,
          message,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.alert {
  background-color: #fee;
}

.gap-2 {
  gap: 0.5rem;
}

.custom-cross-list {
  list-style: none;
  padding-left: 5px !important;

  li {
    position: relative;
    padding-left: 24px;

    &::before {
      content: "✕";
      color: #dc3545;
      font-weight: bold;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
